import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import axios from 'axios'

class ShipmentsRequestCancellerService {
    async cancel(shipmentRequestIds : EntityIdentifiersRequest, originLaboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/shipments/laboratories/${originLaboratoryId}/shipmentRequests/cancel`, { data: shipmentRequestIds })
        return response.data
    }
}

export const shipmentsRequestCancellerService = new ShipmentsRequestCancellerService()
